import { jsx } from "react/jsx-runtime";
import { createElement, useContext, useEffect } from "react";
import react_infinite_scroll_component from "react-infinite-scroll-component";
import { useIsInsideContainer, useSearchSdkOutsideParentNode, useShadowRootElement } from "../hooks/index.js";
import { useStyles } from "./InfiniteScroll.styles.js";
import { InfiniteScrollContext } from "./InfiniteScrollProvider.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function InfiniteScroll_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else InfiniteScroll_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const SCROLLABLE_DIALOG_ID = 'scrollable-dialog';
const InfiniteScroll = (_0)=>{
    let { children, scrollableDialog = false, scrollId, disableContainerHeightCheck, searchSdkScrollOutsideNode, clipRadius, overflowVisible } = _0, props = _object_without_properties(_0, [
        "children",
        "scrollableDialog",
        "scrollId",
        "disableContainerHeightCheck",
        "searchSdkScrollOutsideNode",
        "clipRadius",
        "overflowVisible"
    ]);
    const { classes, cx } = useStyles({
        clipRadius
    });
    const { withOverflow } = props;
    const scrollContext = useContext(InfiniteScrollContext);
    const scrollTarget = scrollableDialog ? SCROLLABLE_DIALOG_ID : scrollContext;
    const isInsideContainer = useIsInsideContainer();
    const scrollWidgetId = useShadowRootElement(scrollId);
    const parentScrollSdkNode = useSearchSdkOutsideParentNode();
    let finalScrollTarget;
    finalScrollTarget = isInsideContainer ? searchSdkScrollOutsideNode ? null != parentScrollSdkNode ? parentScrollSdkNode : scrollWidgetId : scrollWidgetId : null != scrollId ? scrollId : scrollTarget;
    const scrollableKey = 'string' != typeof finalScrollTarget && finalScrollTarget ? 'element-target' : 'string-target';
    useEffect(()=>{
        if (!props.hasMore || props.isLoading || disableContainerHeightCheck) return;
        const container = 'string' == typeof finalScrollTarget ? document.getElementById(finalScrollTarget) : finalScrollTarget;
        if (!container) return;
        const hasScrollbar = container.scrollHeight > container.clientHeight;
        if (!hasScrollbar) props.next();
    }, [
        props.dataLength,
        props.hasMore,
        props.isLoading,
        disableContainerHeightCheck
    ]);
    const className = cx(withOverflow && classes.infiniteScroll, !!clipRadius && classes.clip, overflowVisible && classes.overflowVisible);
    return finalScrollTarget ? /*#__PURE__*/ createElement(react_infinite_scroll_component, _object_spread_props(_object_spread({}, props), {
        className: className,
        key: scrollableKey,
        scrollableTarget: finalScrollTarget
    }), children) : /*#__PURE__*/ jsx(react_infinite_scroll_component, _object_spread_props(_object_spread({}, props), {
        className: className,
        children: children
    }));
};
export { InfiniteScroll };
